import { DateTime } from 'luxon';
import { endsAfterMidnight } from '../../utils/endsAfterMidnight';

export const getStructureDateTimeRange = (
  sessionDate: string,
  startTime: string,
  endTime: string
): { start: DateTime; end: DateTime } => {
  const start = DateTime.fromISO(`${sessionDate}T${startTime}Z`);
  let end = DateTime.fromISO(`${sessionDate}T${endTime}Z`);

  if (endsAfterMidnight(startTime, endTime)) {
    end = end.plus({ days: 1 });
  }

  return { start, end };
};
